import { useEffect, useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import captchaEnviroments from './captchaEnviroments';
import googleRecaptchaActions from './googleRecaptchaActions';

export interface RecaptchaService{
  callIfHuman: (callbackFn: () => void) => void,
  callIfHumanAsync: (callbackFn: ()=>void)=>Promise<void>,
  reCaptchaToken: string | undefined,
  fetchOnce: boolean,
  generateToken: () => Promise<string | undefined>
}

export const useRecaptcha = (action?: googleRecaptchaActions):RecaptchaService => {
  const [fetchOnce, setFetchOnce] = useState(true);
  const [renewal, setRenewal] = useState(false);
  const [reCaptchaToken, setRecaptchaToken] = useState<string | undefined>();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = async () => {
    if (executeRecaptcha) {
      if (captchaEnviroments.STATUS) {
        const token = await executeRecaptcha(action);
        setRecaptchaToken(token);
        return;
      }
      setRecaptchaToken('frontend-recaptcha-desactivated');
    }
  };

  // grap server action to execute when it is possible, also renew token for next request;
  const callIfHuman = (callbackFn: () => void) => {
    if (reCaptchaToken) {
      callbackFn();
      setRenewal(!renewal);
      setFetchOnce(false);
    }
  };

  const callIfHumanAsync = async (callbackFn: () => void) => {
    if (reCaptchaToken) {
      setRenewal(!renewal);
      setFetchOnce(false);
      await callbackFn();
    }
  };

  const generateToken = async () => {
    if (executeRecaptcha) {
      const newToken = await executeRecaptcha(action);
      if (newToken !== reCaptchaToken) {
        return newToken;
      }
    }
  };

  const timer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    handleReCaptchaVerify();
    timer.current = setInterval(handleReCaptchaVerify, 60000);
    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, [renewal, executeRecaptcha]);

  return {
    callIfHuman,
    callIfHumanAsync,
    reCaptchaToken,
    fetchOnce,
    generateToken
  };
};
